import React, { memo, useEffect, useMemo, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import '../../css/PDFViewer.css'; // Import the CSS file
import Loader from './Loader';
import ScrollContainer from './ScrollContainer';

// only for latest version
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';


// lower version [ "react-pdf": "5.7.2", "pdfjs-dist": "2.6.347",]
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min - Copy.js";

// latest version [react-pdf": "^9.1.1]
//   pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";


const PDFViewer = ({ base64 }) => {
    const pdfData = useMemo(() => base64, [base64]);
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageRotations, setPageRotations] = useState({}); // Store each page’s natural rotation
    const [extraRotation, setExtraRotation] = useState(0); // Manual rotation (user clicks)
    const [rotation, setRotation] = useState(0); // Final rotation = natural + manual
    const [isError, setisError] = useState(false);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setLoading(false);
        setNumPages(numPages);
    };

    const onPageLoadSuccess = (page) => {
        // Save the embedded rotation for this page
        setPageRotations((prev) => ({
            ...prev,
            [page.pageNumber]: page.rotate || 0,
        }));
        // Apply it immediately if it’s the current page
        if (page.pageNumber === pageNumber) {
            setRotation(((page.rotate || 0) + extraRotation) % 360);
        }
    };

    // 🔄 When page number or manual rotation changes, compute effective rotation
    useEffect(() => {
        const baseRotation = pageRotations[pageNumber] || 0;
        setRotation((baseRotation + extraRotation) % 360);
    }, [pageNumber, extraRotation, pageRotations]);

    useEffect(() => {
        setLoading(true);
    }, [base64]);

    const handleFirstPage = () => { setPageNumber(1); }
    const handlePrevPage = () => { setPageNumber((prev) => Math.max(prev - 1, 1)); };
    const handleNextPage = () => { setPageNumber((prev) => Math.min(prev + 1, numPages)); }
    const handleLastPage = () => { setPageNumber(numPages); }

    const handleRotate = () => setExtraRotation((prev) => (prev + 90) % 360);


    const renderPdfButtons = () => (
        <div className="pdf-controls">
            <button onClick={handleFirstPage} title='First' className="pdf-btn" disabled={pageNumber === 1}>
                <i className="fa fa-fast-backward"></i>
            </button>
            <button title='Previous' onClick={handlePrevPage} className="pdf-btn" disabled={pageNumber === 1}>
                <i className="fa fa-backward"></i>
            </button>
            <span className="pdf-page-info">{pageNumber} / {numPages}</span>
            <button title='Next' onClick={handleNextPage} className="pdf-btn" disabled={pageNumber === numPages}>
                <i className="fa fa-forward"></i>
            </button>
            <button title='Last' onClick={handleLastPage} className="pdf-btn" disabled={pageNumber === numPages}>
                <i className="fa fa-fast-forward"></i>
            </button>
            <button title='Rotate' onClick={handleRotate} className="pdf-btn">
                <i className="fa fa-repeat"></i> {/* Rotate icon */}
            </button>
        </div>
    );

    const handleDocumentError = (error) => {
        setLoading(false); setisError(true)
    };



    return (
        <>
            <div >
                <ScrollContainer >
                    {(!loading && !isError ) && renderPdfButtons()}
                    {base64?.length != 0 && <Document
                        file={pdfData}
                        loading="Loading file..."
                        onLoadError={handleDocumentError}
                        onLoadSuccess={onDocumentLoadSuccess}
                        className="pdf-view"   // Apply the CSS class here
                    >
                        <Page
                            key={`${pageNumber}-${rotation}`} // ✅ Force re-render on rotation change
                            pageNumber={pageNumber}
                            rotate={rotation}  // Apply rotation
                            onLoadSuccess={onPageLoadSuccess}
                            width={900}        // Set width of the page
                            height={600}   // Set height of the page
                            onRenderError={handleDocumentError}  // 👈 optional
                            onLoadError={handleDocumentError}    // 👈 optional
                        />
                    </Document>}
                    {(!loading && !isError ) && renderPdfButtons()}
                </ScrollContainer>
            </div>
            {loading && <Loader />}
        </>

    );
};

export default memo(PDFViewer);
